import React from 'react'
import { createLayout } from '@dboxdev/ui-components'
import { ScrollLayout } from '@dboxdev/ui-components/gsap'
// Slide-based (16:9 stage) alternative — instead of the two imports above, pull
// SlideLayout from the main entry (it needs no gsap) and swap the shell below:
//   import { createLayout, SlideLayout } from '@dboxdev/ui-components'

import { GlobalStyle, themes, defaultTheme } from 'styles/global-styles'
import useObserver from 'styles/use-observer'

import 'styles/fonts.css'

// Runs once inside the base LayoutProvider (so it can call useLayout) and
// persists across navigation. Return project state (navigation, a splash gate,
// etc.) and read it anywhere via useAppLayout().
const useAppProvider = ({ location }) => {
  // Observer-on-scroll for elements with the .fadeIn class. Not part of the
  // package — see src/styles/use-observer.js. Drop both if unused.
  useObserver(location)

  return {}
}

// Builds the whole layout from a packaged shell: the base LayoutProvider (theme
// + viewport + global-style layers) wraps the shell, which owns the page
// transition. GlobalStyle is the project's Layer 3, rendered in a shell slot so
// it cascades last.
const { Layout, useAppLayout } = createLayout({
  shell: ScrollLayout,
  shellProps: {
    outerBefore: <GlobalStyle />
  },
  layoutProps: {
    themes,
    defaultTheme
    // Design frame sizes ([width, height]) from Figma — set only if they differ
    // from the package defaults (desktop [1920, 1080], mobile [390, 844]). Wide
    // screens scale by height (vh), narrow by width (vw). Slide projects are
    // typically desktop-only — drop the `mobile` entry there.
    // frameSizes: {
    //   desktop: [1920, 1080],
    //   mobile: [390, 844]
    // }
  },
  useAppProvider
})

export { useAppLayout }
export default Layout
